import { render } from "./ScaleQuestionResult.vue?vue&type=template&id=3120b3e4"
import script from "./ScaleQuestionResult.vue?vue&type=script&lang=js"
export * from "./ScaleQuestionResult.vue?vue&type=script&lang=js"

import "./ScaleQuestionResult.vue?vue&type=style&index=0&id=3120b3e4&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__